import {
	createNodeHistory,
	deleteDataNode,
	getAllNodeHistory,
} from 'src/endpoints'

import {
	HistoryDto,
	NewHistoryDto,
	StructureObjectDto,
} from '@/endpoints/models'
import { RootState } from '@/store'
import { apiCallAction, AppDispatch } from '@/store/utils'
import { logError } from '@/utils/errorHandling'

import { loadNodeChildren } from '../node/actions'
import { shouldRefreshParentChildren } from '../node/helpers'
import { HISTORY_GET,HISTORY_PUSH, HISTORY_REVERT } from './constants'

interface PushHistory {
	payload: HistoryDto,
	type: typeof HISTORY_PUSH
}

interface RevertHistory {
	payload: void,
	type: typeof HISTORY_REVERT
}

interface GetHistory {
	metadata: {
		structureId: number
	},
	payload: HistoryDto[]
	type: typeof HISTORY_GET
}

export const pushHistory =
	(node: StructureObjectDto, data: NewHistoryDto, fixImpacts?: boolean) =>
	async (dispatch: AppDispatch, getValues: () => RootState) => {
		await dispatch(
			apiCallAction<PushHistory>(
				() =>
					createNodeHistory(node.id, data, {
						fixImpacts,
					}),
				HISTORY_PUSH,
			),
		)

		// The company ROOT has no ACL: skip refreshing its children (e.g. after pushing a
		// SYSTEM node) to avoid a failed request for non-admin users.
		if (shouldRefreshParentChildren(node, getValues().node.nodes)) {
			try {
				await dispatch(loadNodeChildren(node.parentStructureId as number))
			} catch (e) {
				logError(e, {
					operation: 'pushHistory.loadParentChildren',
					details: { nodeId: node.id, parentStructureId: node.parentStructureId },
				})
			}
		}

		try {
			await dispatch(loadHistory(node.id))
		} catch (e) {
			logError(e, {
				operation: 'pushHistory.loadHistory',
				details: { nodeId: node.id },
			})
		}
	}

export const revertHistory = (id: number) =>
	apiCallAction<RevertHistory>(() => deleteDataNode(id), HISTORY_REVERT)

export const loadHistory = (structureId: number) =>
	apiCallAction<GetHistory>(() => getAllNodeHistory(structureId), HISTORY_GET, {
		structureId,
	})

export type Actions = PushHistory | RevertHistory | GetHistory
